/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

// Composables
import { createRouter, createWebHashHistory } from 'vue-router';
import Routes from '@/enums/Routes';

import privateLayout from '@/layouts/private/private.vue';
import publicLayout from '@/layouts/public/public.vue';

import indexPage from '@/pages/index.vue';
import settingsPage from '@/pages/settings/settings.vue';
import errorPage from '@/pages/404.vue';
import loginPage from '@/pages/auth/login.vue';
import logoutPage from '@/pages/auth/logout.vue';
import changePasswordPage from '@/pages/auth/changepassword.vue';

import useAuth from '@/composables/useAuth/useAuth';

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes: [
    {
      path: Routes.HOME,
      component: privateLayout,
      children: [{ path: '', component: indexPage }],
    },
    {
      path: Routes.NOT_FOUND,
      component: errorPage,
    },
    {
      path: Routes.SETTINGS,
      component: privateLayout,
      children: [{ path: '', component: settingsPage }],
    },
    {
      path: Routes.LOGIN,
      component: publicLayout,
      children: [{ path: '', component: loginPage }],
    },
    {
      path: Routes.LOGOUT,
      component: privateLayout,
      children: [{ path: '', component: logoutPage }],
    },
    {
      path: Routes.CHANGE_PASSWORD,
      component: privateLayout,
      children: [{ path: '', component: changePasswordPage }],
    },
  ],
});

router.beforeEach(async (to) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { isAuthorized } = useAuth();
  const publicPages: Routes[] = [Routes.LOGIN, Routes.LOGOUT];
  const authRequired = !publicPages.includes(to.path as Routes);

  if (to.path === Routes.LOGIN && isAuthorized()) {
    return {
      path: Routes.HOME,
    };
  }

  if (authRequired && !isAuthorized()) {
    return {
      path: Routes.LOGIN,
    };
  }
});

export default router;
